import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppConstants } from 'src/app/common/app.constants';
import { MatDialog } from '@angular/material/dialog';
import { StocksComponent } from '../../stocks.component';
import { StocksModel } from '../../models/stocks.model';
@Component({
    selector: 'app-stocks-summary',
    templateUrl: './stocks-summary.component.html',
    styleUrls: ['./stocks-summary.component.scss'],
    standalone: false
})
export class StocksSummaryComponent {
 @Input() stock: any;

  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  show: boolean = false;
  stocks: any;

  constructor(
    private dialog: MatDialog
  ) {
    let sessionStock = sessionStorage.getItem(AppConstants.SESSION_VAR_STOCK);
    this.stocks = (sessionStock !== null) ? JSON.parse(sessionStock) : [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['stock']) {
    //   this.show = (this.stock !== undefined);

    // }
  }

  /**
   * Closed the summary panel
   */
  close(): void {
    this.show = !this.show;
  }
  /**
   * Edit the current selected item
   */
  onEditAction() {
    this.onEdit.emit(this.stock);
  }
  /**
   * Delete the current item.
   */
  onDeleteAction() {
    this.onDelete.emit(this.stock);
  }

}
